import React, {useEffect, useState} from 'react';
import CanvasJSChart from "../dashboard/CanvasJSChart";
import SpinnerDiv from "../gdpr/ui/SpinnerDiv";
import {getPanelHeader} from "./DashboardPanelFunctions";
import {getDataFromResponse} from "../DataFunctions/BaseDataFns";
import VSFallbackComponent from "./FallbackComponent";
import {ErrorBoundary} from "react-error-boundary";
import {getResourceUsageByResource} from "../DataFunctions/StatisticsDataFns";
import './AdminDashboard.scss'
import DropdownAccessHours from "./ui/DropdownAccessHours";
import DropdownResources from "./ui/DropdownResources";
import {GRAPH_COLORS} from "./constants/S360_constants";

const ResourcePupilUsageBySchool = (props) =>
{
    const [data, setData] = useState({loading: true, data: [], dataPoints: []})
    const [ ah_id, setALId ] = useState ( 0) ;
    const [ resource_id, setResourceId ] = useState (  0);
    const [ resource_name, setResourceName ] = useState (  'All Resources');

    useEffect(() =>
    {
        getServerData(resource_id, ah_id);
    }, [resource_id, ah_id]);

    const getServerData = (resource_id, in_school_hours) =>
    {
        getResourceUsageByResource(resource_id, in_school_hours, 'shared',(response) =>
        {
            const reportData = getDataFromResponse(response);
            let dataPoints = generateChartData ( reportData )  ;
            setData({loading: false, dataPoints: dataPoints, data: reportData});
        });
    }

    const generateChartData = ( chartData ) =>
    {
        return chartData.filter((item) => {
            return item.tag !== 'total' ;
        })
            .map ((item) => {
                return ({
                    y: +item.count,
                    label: item.name,
                    color: GRAPH_COLORS.GRAPH_COLOR_4,
                    cursor: 'pointer',
                    click: () => onRowClick(item.name)
                })
            });
    }

    const rowExtResChart = () =>
    {
        let options = {
            backgroundColor: '#ffffff',
            exportEnabled: true,
            animationEnabled: true,
            title: {
                text: "Access - " + resource_name,
                fontFamily: "verdana",
                fontSize: 16,
            },
            axisX:{
                interval: 1,
                labelFormatter: function ( e ) {
                    return "" ;// + e.value;
                }
            },
            axisY2:{
                interval: 10,
                scaleBreaks: {
                    type: "wavy",
                    customBreaks: [{
                        startValue: 80,
                        endValue: 100
                    },
                        {
                            startValue: 140,
                            endValue: 280
                        },					]}
            },
            data: [{
                type: "bar",
                name: 'Resource Access (Teachers & Pupils)',
                axisYType: "secondary",
                showInLegend: "false",
                legendText: "",
                indexLabelFontSize: 12,
                indexLabel: "{label} - {y}",
                indexLabelFontColor: "black",
                indexLabelPlacement: "inside",
                color: GRAPH_COLORS.GRAPH_COLOR_4,
                dataPoints: data.dataPoints
            }]
        }

        return <CanvasJSChart key='extResourceUsageCanvas' options={options} uniqueId='extResourceUsageCanvas' />
    }

    const onResourceDropdownChange = ( evt, options ) =>
    {
        if ( options.action === 'select-option')
        {
            setResourceId (evt.value) ;
            setResourceName(evt.label);
        }
    };

    const onALDropdownChange = ( evt, options ) =>
    {
        if ( options.action === 'select-option')
        {
            const value = evt.value;
            setALId (value) ;
        }
    };

    if ( data.loading === true )
    {
        return <SpinnerDiv />
    }
    else
    {
        return (
            <ErrorBoundary FallbackComponent={VSFallbackComponent}>
                <div className={'panel ' + props.panelStyle}>
                    {props.title !== '' && getPanelHeader({title: props.title})}
                    <div className='panel-body'>
                        { rowExtResChart() }
                        {data.data.length === 0 && <div> <h4>Sorry there was no data found for this choice.</h4></div>}
                    </div>

                    <div className='panel-body'>
                        { <div className='col-md-6'>
                            <DropdownResources onChange={onResourceDropdownChange}
                                             id='InputResourceDropdown'
                                             label='Select a Resource'
                                             defaultValue={resource_id}
                                             isClearable={false}
                                             value={resource_id}
                                             readOnly={''}
                                             key='InputResourceDropdown'
                                             renderErrorDiv={false}
                                             menuPlacement={'top'}
                                             resType={'shared'}/>
                        </div>}

                        <div className='col-md-6'>
                            <DropdownAccessHours onChange={onALDropdownChange}
                                                 id='InputAHDropdown'
                                                 label='Select in School Hours/Outside School'
                                                 defaultValue={ah_id}
                                                 isClearable={false}
                                                 value={ah_id}
                                                 readOnly=''
                                                 key='InputAHDropdown'
                                                 menuPlacement={'top'}
                                                 renderErrorDiv={false}/>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        )
    }
}

export default ResourcePupilUsageBySchool;

ResourcePupilUsageBySchool.defaultProps =
    {
        title: 'title',
        panelStyle: 'panel-default',
        data: {}
    }